import React, { useContext, useEffect, useState } from "react";
import './Form.css'
import Button from "../button/Button";
import InputField from "../input-field/InputField";
import { FormContext } from "../../app/App";



function cyrillicValidator(event)
{
    event.target.value = event.target.value.replace(/[^А-Яа-яЁё0-9.,]/g, "").replace(/(\..*?)\..*/g, "$1");
}

export default function Form()
{
    const { show, setShow, showMsg, setShowMsg } = useContext(FormContext);
    const { type, setType } = useContext(FormContext);
    const [inputName, setInputName] = useState('');
    const [inputTel, setTel] = useState('');
    const [inputCom, setCom] = useState('');

    const inputsData = [
        {type: 'text', placeholder: 'Ваше имя', name: 'userName', handler: setInputName, state: inputName, form: true},
        {type: 'tel', placeholder: '+7 (___) ___-__-__', name: 'userTel', handler: setTel, state: inputTel, form: true}
    ]
    const handleSubmit = async (e) => {
        e.preventDefault();
        let action = document.querySelector('.userActionType')
        const data = {
          name: inputName,
          tel: inputTel,
          comment: inputCom,
          action: action != undefined ? action.value : null,
          utm: 'airnet_corp_land'
        };
    
        try {
            const response = await fetch('/send.php', {
            method: 'POST',

            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          });
          console.log(response)
          if (response.ok) {
            console.log('Data sent successfully!');
            setShowMsg(!showMsg)
            setShow(!show)

            setTimeout(() => {
              setShowMsg(false)
            }, 4000)
          } else {
            console.log('Failed to send data.');
          }
        } catch (error) {
          console.error('Error:', error);
        }
    };

    useEffect(()  => {
        document.body.style.overflowY = 'hidden';
    
        return () => {
            document.body.style.overflowY = 'auto';
        };
    });

    if(!show) return <></>
    
    return (
        <div className="request-form-field">
            <form onSubmit={handleSubmit} className="request-form" method="POST" href='#'> 
                <h3 className="form-title">Заявка на подключение</h3>
                <button className="close-button" onClick={() => {setShow(!show)}}></button>
                {inputsData.map(input => {
                    return <InputField props={ input }/>
                })}
                <textarea value={inputCom} onChange={(e) => setCom(e.target.value)} maxLength={'100'} onInput={cyrillicValidator} className="userComment" name="userComment" placeholder="Ваш адрес"></textarea>
                { type != undefined ? <><span className="form-type">Выбранная услуга: { type }</span><input className="userActionType" type="hidden" name="userActionType" value={ type }></input></> : ''}
                <Button props={ {disabled: false, button: 'submit', type: 'section-button', name: 'Отправить'} }/>
            </form>
        </div>
    )

}
